import { Component } from '@theme/component';

class AtelierStatementBanner extends Component {
  requiredRefs = ['track'];

  #raf = null;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#raf) cancelAnimationFrame(this.#raf);
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
  }

  #onScroll = () => {
    if (this.#raf) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = null;
      this.#update();
    });
  };

  #update() {
    const track = this.refs.track;
    const vh = window.innerHeight;
    const absTop = this.getBoundingClientRect().top + window.scrollY;
    const scrollStart = Math.max(0, absTop - vh * 0.85);
    const sticky = this.querySelector('.atelier-statement-banner__sticky');
    const stickyH = sticky ? sticky.offsetHeight : vh;
    const scrollEnd = absTop + (this.offsetHeight - stickyH);
    const span = scrollEnd - scrollStart;
    let progress = span > 0 ? (window.scrollY - scrollStart) / span : 0;
    progress = Math.max(0, Math.min(1, progress));

    const amountRaw = getComputedStyle(this).getPropertyValue('--asb-sweep').trim();
    const amount = Math.min(1, Math.max(0.05, (parseFloat(amountRaw) || 100) / 100));
    const overflow = Math.max(0, track.scrollWidth - window.innerWidth) * amount;
    track.style.transform = `translate3d(${(-overflow * progress).toFixed(2)}px, 0, 0)`;
  }
}

if (!customElements.get('atelier-statement-banner')) {
  customElements.define('atelier-statement-banner', AtelierStatementBanner);
}
